import { Row, Col } from "react-bootstrap";
import './PlatformFeatures.css'

const PlatformFeatures = () => {
  const features = [
    {
      title: "Approvals",
      desc: "Route requests, bills, payments, and vendors through a customizable, multi-level approval flow.",
      icon: "/assets/features/approve.png",
    },
    {
      title: "Scalable Pricing",
      desc: "Give the right people category-level budget visibility across all organizational spend.",
      icon: "/assets/features/budget.png",
    },
    {
      title: "Analytics",
      desc: "Get AI-powered spend insights and real-time reports to drive better decisions.",
      icon: "/assets/features/anayltics.png",
    },
    {
      title: "Integrations",
      desc: "Integrate with accounting software, ERP systems, and PunchOut catalogs for easy purchasing.",
      icon: "/assets/features/integrations.png",
    },
    {
      title: "Mobile app",
      desc: "Control and track spending wherever, whenever, and however spending takes place.",
      icon: "/assets/features/mobileapp.png",
    },
    {
      title: "Support",
      desc: "We provide 24/5 support and a dedicated Success Manager to help you succeed.",
      icon: "/assets/features/support.png",
    },
  ];

  return (
    <div className="platform-section">
      {/* <h2 className="text-center mb-5">
        What’s included in the VeNSap Platform
      </h2> */}

      <Row className="g-2">
        {features.map((item, index) => (
          <Col md={4} key={index}>
            <div className="platform-card">
              <img src={item.icon} alt={item.title} className="platform-icon" />
              <hr />
              <h5>{item.title}</h5>
              <p>{item.desc}</p>
              {/* <span className="learn-more">Learn more</span> */}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PlatformFeatures;
